<div *ngIf="isMobile">
  <app-home-mobile></app-home-mobile>
</div>
<div *ngIf="!isMobile">
  <app-home-desktop></app-home-desktop>
</div>

